// The ONE noun per secondary slot — the single source the SecondaryPane
// head reads, so a slot's name cannot drift between the
// switch that opens it and the pane that shows it (inevitability
// I2/I7: one concept, one noun, one voice). A slot's KEY is internal code; its
// NOUN is display, and lives only here.
//
// `msg` descriptors (not localised strings): defined at module scope, each
// consumer localises with `i18n._` at render — the diagnosticMessage.ts idiom.
// The Record is total over SecondarySlot, so a new slot must be named here
// before it can render.
//
// Naming decisions (CC5, the term-registry pass):
//   • grounding → "Quality". The slot hosts the material's quality axes; its
//     INNER factual axis keeps the noun "Grounding" (QualitySummary), so the
//     slot and the axis no longer share one word.
// (The retired "conversation" slot was named "Assistant"; chat now lives in the
// float + its own tab, so the dock no longer names it — subtractive audit.
// The retired "situation-profile" slot was named "Audience"; it now rides the
// chat banner as SituationProfileChip — chat integration Slice 1.)

import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import type { SecondarySlot } from "./AppShell.js";

export const secondarySlotLabels: Readonly<
    Record<SecondarySlot, MessageDescriptor>
> = {
    // Redesign step 1: the chat, docked in the right panel.
    assistant: msg`Assistant`,
    review: msg`Review`,
    grounding: msg`Quality`,
    // Right panel v2: the chat's one panel (materials, sources, other files).
    panel: msg`Context`,
};
